import { createRootRoute, Outlet } from '@tanstack/react-router'
import { useEffect } from 'react'
import { applyAppTheme } from '@/config/app-theme'
import { useSettingsStore } from '@/features/settings/stores/settings-store'

function RootComponent() {
  const appTheme = useSettingsStore((s) => s.appTheme)
  useEffect(() => {
    applyAppTheme(appTheme)
  }, [appTheme])
  return <Outlet />
}

export const Route = createRootRoute({
  component: RootComponent,
})
